import { render, staticRenderFns } from "./EditAddToWorkflow.vue?vue&type=template&id=84caddbc&scoped=true&"
import script from "./EditAddToWorkflow.vue?vue&type=script&lang=js&"
export * from "./EditAddToWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./EditAddToWorkflow.vue?vue&type=style&index=0&id=84caddbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84caddbc",
  null
  
)

export default component.exports